var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "d-flex w-100",
          class: {
            "vuetiful-input-focus":
              _vm.isFocused && !_vm.hasError && !_vm.aiCustom,
            "text-muted": _vm.disabled,
            "vuetiful-input-error": _vm.hasError,
            "border bg-white rounded": !_vm.aiCustom,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "position-relative d-flex align-items-center w-100",
            },
            [
              _vm.label
                ? _c(
                    "label",
                    {
                      staticClass:
                        "position-absolute top-0 mt-0 mb-2 left-0 font-weight-normal vuetiful-label d-flex",
                      class: {
                        "vuetiful-label-small": !_vm.showPlaceholderLabel,
                        "font-size-125": _vm.aiCustom,
                      },
                      attrs: { for: _vm.fieldId, id: "text-area-label" },
                    },
                    [_vm._v(_vm._s(_vm.label))]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.fieldValue.length > 0
                ? _c(
                    "span",
                    {
                      staticClass:
                        "position-absolute top-0 right-0 pt-2 font-size-150 cursor-pointer lh-1 pr-1",
                      on: { click: this.clearField },
                    },
                    [_vm._v("×")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.fieldValue,
                    expression: "fieldValue",
                  },
                ],
                ref: "field",
                staticClass: "no-border no-bg w-100 mt-2",
                class: {
                  "vuetiful-input pl-1": !_vm.aiCustom,
                  "vuetiful-ai-input": _vm.aiCustom,
                },
                attrs: {
                  maxlength: _vm.maxCharacters,
                  rows: _vm.isRowDynamic ? _vm.setRow : _vm.rows,
                  id: _vm.fieldId,
                  name: _vm.name,
                  placeholder: _vm.placeholder,
                },
                domProps: { value: _vm.fieldValue },
                on: {
                  focus: _vm.onFocus,
                  blur: _vm.onBlur,
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.fieldValue = $event.target.value
                  },
                },
              }),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      !_vm.hideLength
        ? _c(
            "div",
            { staticClass: "text-right", class: { "pr-1 mb-2": _vm.aiCustom } },
            [
              _vm._v(
                _vm._s(_vm.inputLength) + " / " + _vm._s(_vm.maxCharacters)
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("Transition", { attrs: { name: "fade-grow" } }, [
        _vm.hasError && _vm.currentError
          ? _c("div", { staticClass: "mt-2 vuetiful-input-error-text" }, [
              _vm._v(
                "\n            " + _vm._s(_vm.currentError) + "\n        "
              ),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }